import { useParams, useRouter } from 'next/navigation';
import { paths } from 'src/config/paths';

import { Button } from '@/design-system/components/ui';

import Logo from '../Logo';

export const HomeButton: React.FC = () => {
  const params = useParams();
  const router = useRouter();

  const homePath = params?.slug ? paths.project.overview(params.slug as string) : '/';
  const navigateHome = () => router.push(homePath);

  return (
    <Button variant="ghost" onClick={navigateHome}>
      <Logo />
    </Button>
  );
};
